import { csvEscape, safeCsvSlug, triggerCsvDownload } from './perfHubCsvUtils';

export const TOP_PERFORMERS_SORT_LABELS = {
  engagement: 'Engagement',
  impressions: 'Impressions',
  reach: 'Reach',
  saved: 'Saves',
  rebook: 'Re-book score',
  ugc: 'UGC score',
  spend: 'Spend',
  cpe: 'CPE (lowest first)',
  efficiency: 'Efficiency score',
  efficiency_cpe: 'CPE (value-led)',
  crm: 'Shortlist status',
};

const TREND_LABELS = {
  improving: 'Improving',
  declining: 'Declining',
  flat: 'Flat',
};

export function formatFilterLabel(filterId, options) {
  if (!filterId) return 'All';
  const hit = (options || []).find((o) => o.id === filterId);
  return hit?.label || filterId;
}

export function buildFilterSlug(formatFilter, driverFilter, filters) {
  const fmt = formatFilter
    ? safeCsvSlug(formatFilterLabel(formatFilter, filters?.format))
    : 'all-formats';
  const drv = driverFilter
    ? safeCsvSlug(formatFilterLabel(driverFilter, filters?.driver))
    : 'all-drivers';
  return `${fmt}_${drv}`;
}

export function buildTopPerformersCsvRows(performers, { economicsConfigured }) {
  const headers = [
    'instagram_handle',
    'post_url',
    'permalink',
    'invite_status',
    'engagement',
    'impressions',
    'reach',
    'saved',
    'rebook_score',
    'ugc_score',
    'ugc_suggested',
    'trend',
    'likes',
    'comments',
    'impressions',
    'plays',
    'shortlist_status',
    'row_id',
  ];

  if (economicsConfigured) {
    headers.push('spend_inr', 'cost_per_1k_reach_inr', 'cpe_engagement_inr', 'fee_inr', 'allocation');
  }

  const lines = [headers.map(csvEscape).join(',')];

  for (const tp of performers) {
    const row = tp.row || {};
    const snap = tp.snapshot || {};
    const intel = tp.intel || {};
    const econ = tp.economics || {};
    const base = [
      row.instagram_handle,
      row.post_url,
      snap.permalink || tp.postLink,
      row.invite_status,
      tp.engagement,
      tp.impressions,
      tp.reach,
      tp.saved,
      intel.rebook_score,
      intel.ugc_score,
      intel.ugc_suggested ? 'yes' : 'no',
      TREND_LABELS[intel.trend] || intel.trend || '',
      snap.likes,
      snap.comments,
      snap.plays,
      snap.saved,
      tp.shortlist_status,
      row.id,
    ];

    if (economicsConfigured) {
      base.push(
        econ.spend_inr,
        econ.cost_per_1k_reach_inr,
        econ.cpe_engagement_inr,
        econ.fee_inr,
        econ.allocation,
      );
    }

    lines.push(base.map(csvEscape).join(','));
  }

  return lines.join('\n');
}

export function downloadTopPerformersCsv(
  performers,
  {
    campaignName,
    sortKey,
    economicsConfigured,
    formatFilter = '',
    driverFilter = '',
    filters = {},
  },
) {
  if (!performers?.length) return;

  const filterSlug = buildFilterSlug(formatFilter, driverFilter, filters);
  const safeCampaign = safeCsvSlug(campaignName) || 'campaign';
  const sortSlug = safeCsvSlug(TOP_PERFORMERS_SORT_LABELS[sortKey] || sortKey || 'sorted');
  const csv = buildTopPerformersCsvRows(performers, { economicsConfigured });
  triggerCsvDownload(`top-performers-${safeCampaign}-${filterSlug}-${sortSlug}.csv`, csv);
}
